/*
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2021-08-10 12:26:43
 * @LastEditTime: 2022-09-28 15:53:27
 * @Description: file content
 */
import request from "@/utils/request";

// const requestUrl = window.env.userAccesss;
const requestUrl = window.env.scimSystem;

const user = {
  login: data => request({
    url: `${requestUrl}/api/v1/auth/login`,
    method: "post",
    data
  }),
  // 第三方登录
  thirdPartyLogin: data => request({
    url: `${requestUrl}/api/v1/auth/third-party/login`,
    method: "post",
    data
  }),
  logout: () => request({
    url: `${requestUrl}/api/v1/auth/logout`,
    method: "post"
  }),

  getInfo: () => request({
    url: `${requestUrl}/api/v1/user/info`,
    method: "get"
  }),

  getResource: params => request({
    url: `${requestUrl}/api/v1/user/resource`,
    method: "get",
    params
  }),
  changeInitPassword: data => request({
    url: `${requestUrl}/api/v1/auth/changeInitPassword`,
    method: "post",
    data
  }),
  getLoginCode: data => request({
    url: `${requestUrl}/api/v1/auth/login/send-sms`,
    method: "post",
    data
  }),
  loginByPhone: data => request({
    url: `${requestUrl}/api/v1/auth/login/validate-sms`,
    method: "post",
    data
  }),
  judgeLogin: () => request({
    url: `${requestUrl}/api/v1/auth/judgeLogin`,
    method: "post"
  }),
  getToken() {
    return request({
      url: `${requestUrl}/api/v1/user/token`,
      method: "get"
    });
  },

  /**
   * @description: 获取子应用的配置
   * @param {*}
   * @return {*}
   */
  getMircAppConfig(params) {
    return request({
      url: `${requestUrl}/api/v1/parameter-config/config-key/FRONT_ROUTER/value`,
      method: "get",
      params
    });
  },
  // 获取公钥
  getPublicKey: () => request({
    url: `${requestUrl}/api/v1/auth/public-key`,
    method: `get`
  }),
  // 获取是否使用图片验证
  getCaptchaStatus: () => request({
    url: `${requestUrl}/api/v1/auth/use-captcha-status`,
    method: `post`
  }),
  // 修改密码
  modifyPassword: () => request({
    url: `${requestUrl}/api/v1/auth/remind/modify-password`,
    method: `post`
  })
};
export default user;
